/**
 * Medical & Healthcare Icons
 * 
 * Healthcare domain icons for patient management, medical records,
 * medications, and clinical features.
 * 
 * Used by: Knowledge base medical features, health dashboard
 */

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  // Practitioners & Facilities
  faStethoscope as fadStethoscope,
  faUserDoctor as fadUserDoctor,
  faUserNurse as fadUserNurse,
  faHospital as fadHospital,
  faHospitalUser as fadHospitalUser,
  faTruckMedical as fadTruckMedical,
  faLaptopMedical as fadLaptopMedical,
  faHouseMedical as fadHouseMedical,
  
  // Medical Records & Documentation
  faNoteMedical as fadNoteMedical,
  faNotesMedical as fadNotesMedical,
  faFileMedical as fadFileMedical,
  faFilesMedical as fadFilesMedical,
  faCommentMedical as fadCommentMedical,
  faMemoCircleCheck as fadMemoCircleCheck,
  faMemoCircleInfo as fadMemoCircleInfo,
  faClipboardListCheck as fadClipboardListCheck,
  
  // Medications & Prescriptions
  faPrescriptionBottle as fadPrescriptionBottle,
  faPrescriptionBottlePill as fadPrescriptionBottlePill,
  faPrescriptionBottleMedical as fadPrescriptionBottleMedical,
  faPrescription as fadPrescription,
  faPills as fadPills,
  faTablets as fadTablets,
  faCapsules as fadCapsules,
  faEyeDropperHalf as fadEyeDropperHalf,
  faSyringe as fadSyringe,
  faAllergies as fadAllergies,
  
  // Health & Vitals
  faHeartPulse as fadHeartPulse,
  faHeartCircleCheck as fadHeartCircleCheck,
  faHeartCircleBolt as fadHeartCircleBolt,
  faHeadSideBrain as fadHeadSideBrain,
  faBrain as fadBrain,
  faLungs as fadLungs,
  faDroplet as fadDroplet,
  faWeightScale as fadWeightScale,
  faBedPulse as fadBedPulse,
  faHeartbeat as fadHeartbeat,
  
  // Care & Treatment
  faUsersMedical as fadUsersMedical,
  faUserDoctorMessage as fadUserDoctorMessage,
  faXRay as fadXRay,
  faScalpelLineDashed as fadScalpelLineDashed,
  faHandHoldingMedical as fadHandHoldingMedical,
  faFlaskVial as fadFlaskVial,
  
  // Wellness & Health Activities
  faDumbbell as fadDumbbell,
  faHandsHoldingHeart as fadHandsHoldingHeart,
  faHandHoldingHeart as fadHandHoldingHeart,
  faSpa as fadSpa,
  faPersonWalking as fadPersonWalking,
  faPersonFalling as fadPersonFalling,
  faGlassWater as fadGlassWater,
  faAppleWhole as fadAppleWhole,
  faWheelchair as fadWheelchair,
  faFacePensive as fadFacePensive,

  // Device Health (Apple Health / Health Connect widget)
  faShoePrints as fadShoePrints,
  faFireFlameCurved as fadFireFlameCurved,
  faStairs as fadStairs,
  faTemperatureHalf as fadTemperatureHalf,
  faRulerVertical as fadRulerVertical,
  faPerson as fadPerson,
  faDrumstickBite as fadDrumstickBite,
  faBreadSlice as fadBreadSlice,
} from "@fortawesome/pro-duotone-svg-icons";

import {
  faClipboardListCheck as fasClipboardListCheck,
} from "@fortawesome/pro-solid-svg-icons";

import {
  faHospitalUser as fatHospitalUser,
} from "@fortawesome/pro-thin-svg-icons";

export const loadMedicalIcons = () => {
  // Duotone medical icons
  library.add(
    // Practitioners & Facilities
    fadStethoscope,
    fadUserDoctor,
    fadUserNurse,
    fadHospital,
    fadHospitalUser,
    fadTruckMedical,
    fadLaptopMedical,
    fadHouseMedical,
    
    // Medical Records
    fadNoteMedical,
    fadNotesMedical,
    fadFileMedical,
    fadFilesMedical,
    fadCommentMedical,
    fadMemoCircleCheck,
    fadMemoCircleInfo,
    fadClipboardListCheck,
    
    // Medications
    fadPrescriptionBottle,
    fadPrescriptionBottlePill,
    fadPrescriptionBottleMedical,
    fadPrescription,
    fadPills,
    fadTablets,
    fadCapsules,
    fadEyeDropperHalf,
    fadSyringe,
    fadAllergies,
    
    // Health & Vitals
    fadHeartPulse,
    fadHeartCircleCheck,
    fadHeartCircleBolt,
    fadHeadSideBrain,
    fadBrain,
    fadLungs,
    fadDroplet,
    fadWeightScale,
    fadBedPulse,
    fadHeartbeat,
    
    // Care & Treatment
    fadUsersMedical,
    fadUserDoctorMessage,
    fadXRay,
    fadScalpelLineDashed,
    fadHandHoldingMedical,
    fadFlaskVial,
    
    // Wellness
    fadDumbbell,
    fadHandsHoldingHeart,
    fadHandHoldingHeart,
    fadSpa,
    fadPersonWalking,
    fadPersonFalling,
    fadGlassWater,
    fadAppleWhole,
    fadWheelchair,
    fadFacePensive,

    // Device Health
    fadShoePrints,
    fadFireFlameCurved,
    fadStairs,
    fadTemperatureHalf,
    fadRulerVertical,
    fadPerson,
    fadDrumstickBite,
    fadBreadSlice,
  );

  // Solid medical icons
  library.add(fasClipboardListCheck);

  // Thin medical icons
  library.add(fatHospitalUser);
};
